import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useAuth, UserButton } from '@clerk/clerk-react';
import { useClerk } from '@clerk/clerk-react';
import ConnectionStatusIcon from '../shared/ConnectionStatusIcon';
import { ClerkAccountSkin, ClerkSignInSkin } from './ClerkSkins';
import config from '../../config.json';

/**
 * AppBar action buttons - sign in/up or user button + connection status
 */
export default function AppBarActions() {
    const { isSignedIn } = useAuth();
    const { openSignIn, openSignUp } = useClerk();

    if (!isSignedIn) {
        return (
            <Box sx={{ display: 'flex', gap: 1 }}>
                {!config.comingSoon && (
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => openSignIn(ClerkSignInSkin)}
                        sx={{
                            color: '#a3d1ff',
                            textTransform: 'none',
                            '&:hover': { bgcolor: 'rgba(102, 178, 255, 0.08)' },
                        }}
                    >
                        Sign in
                    </Button>
                )}
                {!config.comingSoon && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => openSignUp(ClerkSignInSkin)}
                        sx={{
                            bgcolor: '#66b2ff',
                            color: '#0d0d1a',
                            textTransform: 'none',
                            '&:hover': { bgcolor: '#4ca0ff' },
                        }}
                    >
                        Sign up
                    </Button>
                )}
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ConnectionStatusIcon />
            <UserButton userProfileUrl="/dashboard" appearance={ClerkAccountSkin} />
        </Box>
    );
}
